import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MDownloadComponent } from './download.component';

@NgModule({
  declarations: [MDownloadComponent],
  exports: [MDownloadComponent],
  imports: [CommonModule, NzButtonModule, NzDropDownModule, NzIconModule]
})
export class MDownloadModule {}
